module.exports = __webpack_public_path__ + "static/Aviva-Dolls-House-345692b8abf2205721433a6551db7861.mp4";